import { Download, MessageCircle, Ruler, Layers, Package2, ArrowDown } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const products = [
  {
    name: "Acrylic Sheet Bening",
    slug: "bening",
    desc: "Transparan jernih, ideal untuk display, signage, dan aplikasi yang menonjolkan kejernihan material.",
    swatch: "#F1F5F8",
    border: "border-neutral-200",
  },
  {
    name: "Acrylic Sheet Putih",
    slug: "putih",
    desc: "Putih susu (milky white) yang tembus cahaya — bukan putih solid. Sangat ideal untuk huruf timbul, panel interior, dan backlit signage.",
    swatch: "#FFFFFF",
    border: "border-neutral-200",
    note: "Putih Susu · Tembus Cahaya",
  },
  {
    name: "Acrylic Sheet Hitam",
    slug: "hitam",
    desc: "Hitam pekat dengan permukaan mengilap, memberi kesan elegan untuk furniture dan dekorasi.",
    swatch: "#111111",
    border: "border-neutral-800",
  },
  {
    name: "Acrylic Sheet Biru",
    slug: "biru",
    desc: "Biru solid untuk kebutuhan corporate signage, display, hingga aplikasi interior modern.",
    swatch: "#2563EB",
    border: "border-blue-200",
  },
  {
    name: "Acrylic Sheet Merah",
    slug: "merah",
    desc: "Merah terang dengan tampilan tajam untuk signage, huruf timbul, dan branding yang menonjol.",
    swatch: "#F5222D",
    border: "border-red-200",
  },
  {
    name: "Acrylic Sheet Kuning",
    slug: "kuning",
    desc: "Kuning cerah solid untuk display, dekorasi, dan aplikasi visual yang eye-catching.",
    swatch: "#FFD600",
    border: "border-yellow-200",
  },
];

const THICKNESSES = ["2mm", "3mm", "5mm"];
const SIZE = "122 × 244 cm";

export const Products = () => {
  return (
    <section id="produk" data-testid="products-section" className="py-14 sm:py-24 lg:py-32 bg-animax-gray relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative">
        <div className="lg:flex lg:items-end lg:justify-between lg:gap-8">
          <div className="max-w-3xl">
            <div className="tag-uppercase text-animax-orange mb-3 sm:mb-4">Katalog Produk</div>
            <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black">
              Pilihan ANIMAX Acrylic Sheet
            </h2>
            <p className="mt-3 sm:mt-4 text-neutral-600 text-sm sm:text-lg leading-relaxed">
              Tersedia dalam 6 pilihan warna, 3 pilihan ketebalan, dan ukuran standar {SIZE} per lembar
              dengan harga kompetitif untuk kebutuhan retail, produksi, maupun proyek. Cocok untuk
              signage, display, interior, furniture, hingga aplikasi industri.
            </p>
          </div>
          <a
            href="/catalogs/catalogue-acrylic-animax.pdf"
            download
            data-testid="products-download-catalog"
            onClick={() =>
              trackEvent("download_catalog", {
                category: "download",
                label: "Catalogue Acrylic Animax",
                product_name: "Acrylic",
              })
            }
            className="mt-5 lg:mt-0 shrink-0 inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3 rounded-full bg-animax-black text-white font-medium text-sm hover:bg-animax-orange transition-all"
          >
            <Download className="w-4 h-4" />
            Download Katalog
          </a>
        </div>

        {/* Catalog Spec Bar */}
        <div className="mt-8 sm:mt-10 grid grid-cols-3 md:grid-cols-3 gap-2 sm:gap-4" data-testid="catalog-spec-bar">
          <div className="p-3 sm:p-5 rounded-xl bg-white border border-neutral-200">
            <div className="w-8 h-8 sm:w-11 sm:h-11 rounded-lg bg-animax-yellow/20 flex items-center justify-center mb-3">
              <Package2 className="w-4 h-4 sm:w-5 sm:h-5 text-animax-orange" />
            </div>
            <div>
              <div className="tag-uppercase text-neutral-500">Pilihan Warna</div>
              <div className="mt-1 text-animax-black text-sm sm:text-base font-medium">6 Warna</div>
              <div className="hidden sm:block text-xs text-neutral-500 mt-0.5">Bening · Putih · Hitam · Biru · Merah · Kuning</div>
            </div>
          </div>
          <div className="p-3 sm:p-5 rounded-xl bg-white border border-neutral-200">
            <div className="w-8 h-8 sm:w-11 sm:h-11 rounded-lg bg-animax-yellow/20 flex items-center justify-center mb-3">
              <Layers className="w-4 h-4 sm:w-5 sm:h-5 text-animax-orange" />
            </div>
            <div>
              <div className="tag-uppercase text-neutral-500">Ketebalan</div>
              <div className="mt-1 text-animax-black text-sm sm:text-base font-medium">2 · 3 · 5mm</div>
              <div className="hidden sm:block text-xs text-neutral-500 mt-0.5">3 pilihan standar tersedia</div>
            </div>
          </div>
          <div className="p-3 sm:p-5 rounded-xl bg-white border border-neutral-200">
            <div className="w-8 h-8 sm:w-11 sm:h-11 rounded-lg bg-animax-yellow/20 flex items-center justify-center mb-3">
              <Ruler className="w-4 h-4 sm:w-5 sm:h-5 text-animax-orange" />
            </div>
            <div>
              <div className="tag-uppercase text-neutral-500">Ukuran Standar</div>
              <div className="mt-1 text-animax-black text-sm sm:text-base font-medium leading-tight">{SIZE}</div>
              <div className="hidden sm:block text-xs text-neutral-500 mt-0.5">Per lembar — ukuran standar</div>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-10 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
          {products.map((p, i) => (
            <article
              key={p.slug}
              data-testid={`product-card-${p.slug}`}
              className={`card-lift group rounded-xl sm:rounded-2xl overflow-hidden bg-white border ${p.border}`}
            >
              <div
                className="aspect-[5/3.4] sm:aspect-[5/4] relative overflow-hidden"
                style={{ background: p.swatch }}
              >
                <div className="absolute top-2 left-2 sm:top-4 sm:left-4 tag-uppercase text-white/90 mix-blend-difference">
                  0{i + 1} · Warna
                </div>
                <div className="absolute bottom-2 right-2 sm:bottom-4 sm:right-4 px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full glass-light">
                  <span className="text-[8px] sm:text-[10px] tracking-[0.14em] sm:tracking-widest uppercase font-medium text-animax-black">
                    UV Protected
                  </span>
                </div>
                {p.note && (
                  <div className="absolute bottom-2 left-2 sm:bottom-4 sm:left-4 max-w-[calc(100%-1rem)] sm:max-w-none px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full bg-animax-yellow" data-testid={`product-note-${p.slug}`}>
                    <span className="block text-[8px] sm:text-[10px] tracking-[0.12em] sm:tracking-widest uppercase font-medium text-animax-black leading-tight">
                      {p.note}
                    </span>
                  </div>
                )}
              </div>

              <div className="p-3 sm:p-6">
                <h3 className="font-display text-base sm:text-xl font-medium text-animax-black">{p.name}</h3>
                <p className="mt-1.5 sm:mt-2 text-[11px] sm:text-sm text-neutral-600 leading-relaxed sm:min-h-[60px]">{p.desc}</p>

                <div className="mt-3 sm:mt-5 space-y-2 sm:space-y-2.5">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 p-2.5 sm:p-3 rounded-lg bg-neutral-50 border border-neutral-200">
                    <div className="flex items-center gap-2">
                      <Layers className="w-3.5 h-3.5 text-animax-orange" />
                      <span className="tag-uppercase text-neutral-500">Ketebalan</span>
                    </div>
                    <div className="flex gap-1.5">
                      {THICKNESSES.map((t) => (
                        <span key={t} className="px-2 py-0.5 rounded-md bg-animax-black text-white text-[10px] font-medium">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 p-2.5 sm:p-3 rounded-lg bg-neutral-50 border border-neutral-200">
                    <div className="flex items-center gap-2">
                      <Ruler className="w-3.5 h-3.5 text-animax-orange" />
                      <span className="tag-uppercase text-neutral-500">Ukuran</span>
                    </div>
                    <span className="text-xs text-animax-black font-medium">{SIZE}</span>
                  </div>
                </div>

                <div className="mt-3 sm:mt-5">
                  <a
                    href="/kontak#kontak"
                    data-testid={`product-ask-${p.slug}`}
                    onClick={() =>
                      trackEvent("click_tanya_harga", {
                        category: "product",
                        label: p.name,
                        product_name: "Acrylic",
                        product_variant: p.name,
                      })
                    }
                    className="w-full inline-flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 rounded-full bg-animax-black text-white text-xs font-medium hover:bg-animax-orange transition-all"
                  >
                    <MessageCircle className="w-3.5 h-3.5" />
                    Tanya Harga & Stok
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 sm:mt-10 space-y-3 sm:space-y-4">
          <div className="p-4 sm:p-5 rounded-xl bg-white border border-dashed border-neutral-300 text-sm text-neutral-600 leading-relaxed" data-testid="products-note">
            <strong className="text-animax-black">Catatan:</strong> Seluruh produk tersedia dalam
            ukuran standar {SIZE} per lembar — saat ini kami belum melayani custom order/ukuran.
            Untuk informasi lebih detail, silakan hubungi kami langsung.
          </div>
          <div className="p-4 sm:p-5 rounded-xl bg-white border border-dashed border-neutral-300 text-sm text-neutral-600 leading-relaxed" data-testid="products-color-disclaimer">
            <strong className="text-animax-black">Keterangan Warna:</strong> Warna yang ditampilkan
            pada katalog ini merupakan ilustrasi digital dan dapat berbeda dengan warna fisik produk
            aktual akibat perbedaan pengaturan layar dan pencahayaan. Untuk memastikan kesesuaian
            warna, silakan konsultasikan kebutuhan Anda dengan tim kami.
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <a
            href="/kontak#kontak"
            data-testid="products-to-sales"
            onClick={() =>
              trackEvent("click_tanya_harga", {
                category: "product",
                label: "Lihat Kontak Tim Sales Kami",
                product_name: "Acrylic",
              })
            }
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-animax-yellow text-animax-black text-sm font-medium hover:bg-animax-orange hover:text-white transition-all"
          >
            Lihat Kontak Tim Sales Kami
            <ArrowDown className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};
